/**
 * A utils file that contains common helper functions and variables related to search/Yext.
 */

import { Matcher } from '@yext/search-headless-react';
import { DE_DE, EN_AU, EN_IN, EN_UK, EN_US } from './geo-space-id-helpers';

// URL Parameters
export const URL_PARAMS_QUERY = 'query';
export const URL_PARAMS_FILTER = 'filter';
export const URL_PARAMS_FACET_TAG = 'tag';
export const URL_PARAMS_PAGE = 'page';
export const URL_PARAMS_TYPE = 'type';
export const URL_PARAMS_CATEGORY = 'category';
export const URL_PARAMS_DISPLAY_COUNT = 'displayCount';

// Entity Type IDs
export const ENTITY_TYPE_CASE_STUDY = 'ce_caseStudy';
export const ENTITY_TYPE_INSIGHT = 'ce_insight';
export const ENTITY_TYPE_SERVICE = 'ce_service';
export const ENTITY_TYPE_INDUSTRY = 'ce_industry';
export const ENTITY_TYPE_PARTNERSHIP = 'ce_partnership';

// Vertical Keys
export const VERTICAL_ALL_CONTENT = 'all_content';
export const VERTICAL_CASE_STUDIES = 'case_studies';
export const VERTICAL_INSIGHTS = 'insights';
export const VERTICAL_SERVICES = 'services';
export const VERTICAL_INDUSTRIES = 'industries';
export const VERTICAL_PARTNERSHIPS = 'partnerships';

// Facet field IDs
export const FACET_CASE_STUDIES_CATEGORY = 'c_categories';
export const FACET_CASE_STUDIES_TOOL = 'c_tools';
export const FACET_INSIGHTS_INSIGHT_TYPE = 'c_insightType';
export const FACET_INSIGHTS_INSIGHT_CATEGORY = 'c_insightCategory';

/**
 * Function that sets the locale static filters to filter locale specific content.
 * Must pass searchActions object to prevent React hooks error.
 */
export const setGeoStaticFilters = (searchActions, geoSpace) => {
  // Maps the geo space slugs to the locale values set in Yext
  const localeFilterMap = {
    [EN_US]: 'US',
    [EN_UK]: 'UK',
    [EN_AU]: 'AU',
    [DE_DE]: 'DE',
    [EN_IN]: 'IN'
  };

  searchActions.setStaticFilters([
    {
      filter: { fieldId: 'c_locale', matcher: Matcher.Equals, value: 'GLOBAL', kind: 'fieldValue' },
      selected: true
    },
    {
      filter: {
        fieldId: 'c_locale',
        matcher: Matcher.Equals,
        value: `${localeFilterMap[geoSpace]}`,
        kind: 'fieldValue'
      },
      selected: true
    }
  ]);
};
